import Card from '@components/Card';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { OrderLine } from '@models/order';
import { useTranslation } from 'react-i18next';

import SoldOut from './SoldOut';

interface Props {
    item: OrderLine;
}

function CartImage({ item }:Props) {
    const { t } = useTranslation('cart');
    const { itemImageUrl, status } = item;
    const isSoldOut = status === 'SOLD_OUT';
    const disabled = status === 'PENDING' || status === 'DISCONTINUED';
    return (
        <ImageCard >
            <Image src={itemImageUrl}
                width={100}
                height={100}
                alt={t('item.imageAlt')} />
            {isSoldOut && (
                <SoldOut/>
            )}
            {disabled && (
                <Disabled>
                    <Text color={colors.white} fontWeight='bold' align='center'>
                        {t('item.discontinued')}
                    </Text>
                </Disabled>
            )}
        </ImageCard>
    );
}

const Disabled = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ImageCard = styled(Card)`
    max-width: 100px;
    min-width: 100px;
    width: 100px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default CartImage;
